import React from 'react';
import PageHero from '../components/site/PageHero';
import { investors, stats } from '../mock';
import { CtaBanner } from '../components/site/BottomSections';
import { TrendingUp } from 'lucide-react';

export default function Investors() {
  return (
    <div>
      <PageHero eyebrow="Investor Relations" 
      title="A business built on trust and land." 
      subtitle="Numbers, disclosures and updates for our shareholders and partners." 
      image="https://images.pexels.com/photos/25851501/pexels-photo-25851501.jpeg" />
      <section className="bg-white py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="grid md:grid-cols-4 gap-px bg-[#0f1a14]/10 border border-[#0f1a14]/10 mb-16">
            {stats.map((s) => (
              <div key={s.label} className="bg-white p-8">
                <div className="font-serif text-5xl text-[#0f1a14]">{s.value}</div>
                <div className="text-xs uppercase tracking-[0.25em] text-[#8a6b3a] mt-3">{s.label}</div>
              </div>
            ))}
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {investors.map((i, k) => (
              <div key={k} className="p-8 border border-[#0f1a14]/10 hover:border-[#8a6b3a] transition-colors bg-[#f6f1e7]/40">
                <TrendingUp className="h-6 w-6 text-[#8a6b3a]" />
                <h3 className="font-serif text-2xl text-[#0f1a14] mt-4">{i.title}</h3>
                <div className="h-px w-8 bg-[#8a6b3a] my-4" />
                <p className="text-[#0f1a14]/70 leading-relaxed">{i.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <CtaBanner />
    </div>
  );
}
